export default __webpack_public_path__ + "static/media/ai_icon_bl.b0094dce.png";